import { useRenderChildrenFilter } from '@aibees/elephant/feature/search-filters/filters/children-filter/use-render-children-filter';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import type { ChildrenFilterProps as Props } from './types';

export const ChildrenFilter = memo(({ className, open, ...filter }: Props) => {
  const content = useRenderChildrenFilter(filter, open ?? false);
  if (!open || !content) return null;
  return (
    <Box
      className={classnames('ChildrenFilter', className)}
      display={'flex'}
      flexDirection={'column'}
      gap={1}
    >
      {content}
    </Box>
  );
});

ChildrenFilter.displayName = 'ChildrenFilter';
